import { X, Download, Share, Plus } from 'lucide-react';
import { usePWAInstall } from '../../hooks/usePWAInstall';

export function PWAInstallPrompt() {
  const { 
    isInstallable, 
    isInstalled, 
    isIOS, 
    showPrompt, 
    promptInstall, 
    dismissPrompt 
  } = usePWAInstall();

  // Don't show if already installed or not installable
  if (isInstalled || !isInstallable || !showPrompt) {
    return null;
  }

  const handleInstall = async () => {
    if (!isIOS) {
      await promptInstall();
    }
    // For iOS, we just show instructions, user has to do it manually
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 max-w-md mx-auto overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary-500 to-primary-600 px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 rounded-lg p-2">
              <Download className="w-5 h-5 text-white" />
            </div>
            <span className="text-white font-semibold">Telepítsd az alkalmazást!</span>
          </div>
          <button
            onClick={dismissPrompt}
            className="text-white/80 hover:text-white transition-colors p-1"
            aria-label="Bezárás"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          {isIOS ? (
            // iOS specific instructions
            <div className="space-y-3">
              <p className="text-gray-700 text-sm">
                Kövesd ezeket a lépéseket a Pain-Gain telepítéséhez:
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-3 bg-gray-50 rounded-lg p-3">
                  <div className="bg-primary-100 rounded-full p-2">
                    <Share className="w-4 h-4 text-primary-600" />
                  </div>
                  <span className="text-sm text-gray-700">
                    1. Koppints a <strong>Megosztás</strong> gombra
                  </span>
                </div>
                <div className="flex items-center gap-3 bg-gray-50 rounded-lg p-3">
                  <div className="bg-primary-100 rounded-full p-2">
                    <Plus className="w-4 h-4 text-primary-600" />
                  </div>
                  <span className="text-sm text-gray-700">
                    2. Válaszd a <strong>"Főképernyőhöz adás"</strong> opciót
                  </span>
                </div>
              </div>
              <button
                onClick={dismissPrompt}
                className="w-full py-2.5 text-sm text-gray-500 hover:text-gray-700 transition-colors"
              >
                Értem, később telepítem
              </button>
            </div>
          ) : (
            // Android / Chrome instructions
            <div className="space-y-3">
              <p className="text-gray-700 text-sm">
                Telepítsd a Pain-Gain alkalmazást a kezdőképernyődre a gyorsabb eléréshez és offline használathoz!
              </p>
              <div className="flex gap-2">
                <button
                  onClick={handleInstall}
                  className="flex-1 bg-primary-600 hover:bg-primary-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  <Download className="w-4 h-4" />
                  Telepítés
                </button>
                <button
                  onClick={dismissPrompt}
                  className="px-4 py-2.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  Később
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
